(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const drawerSelector = 'header-drawer > details[open], menu-drawer > details[open], .mobile-facets__disclosure[open]';
  const widgetSelector = 'shopify-chat, #pushowl-shadow-host, [id^="pushowl-popup-campaign-"]';
  const savedWidgets = new Map();
  const watchedRoots = new WeakSet();
  let pending = false;

  function openDrawer() {
    return Array.from(document.querySelectorAll(drawerSelector)).find(drawer => drawer.getClientRects().length);
  }

  function suspendWidgets(blocked) {
    document.documentElement.classList.toggle('bb-drawer-open', blocked);
    if (blocked) {
      document.querySelectorAll(widgetSelector).forEach(widget => {
        if (!savedWidgets.has(widget)) savedWidgets.set(widget, { inert: widget.inert, hidden: widget.getAttribute('aria-hidden') });
        widget.inert = true;
        widget.setAttribute('aria-hidden', 'true');
      });
    } else {
      savedWidgets.forEach((saved, widget) => {
        widget.inert = saved.inert;
        if (saved.hidden === null) widget.removeAttribute('aria-hidden');
        else widget.setAttribute('aria-hidden', saved.hidden);
      });
      savedWidgets.clear();
    }
  }

  function chatButton(node) {
    if (!node) return null;
    const button = node.querySelector('[part~="activator"]');
    if (button) return button;
    for (const child of node.querySelectorAll('*')) {
      if (child.shadowRoot) {
        const nested = chatButton(child.shadowRoot);
        if (nested) return nested;
      }
    }
    return null;
  }

  function watchChat(node) {
    if (!node) return;
    if (!watchedRoots.has(node)) {
      watchedRoots.add(node);
      new MutationObserver(schedule).observe(node, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded', 'view', 'class'] });
    }
    for (const child of node.querySelectorAll('*')) {
      if (child.shadowRoot) watchChat(child.shadowRoot);
    }
  }

  function check() {
    pending = false;
    const root = document.documentElement;
    const drawer = openDrawer();
    suspendWidgets(!!drawer);
    const chat = document.querySelector('shopify-chat');
    watchChat(chat?.shadowRoot);
    const button = chatButton(chat?.shadowRoot);
    if (!mobile.matches || drawer || !button || button.getAttribute('aria-expanded') === 'true') {
      root.classList.remove('bb-chat-clear');
      return;
    }
    const overlay = document.querySelector('details-modal details[open], cart-drawer.active, quick-add-modal[open], product-modal[open], modal-dialog[open], dialog[open]');
    const area = button.getBoundingClientRect();
    const targets = document.querySelectorAll('#MainContent button, #MainContent a, #MainContent input, #MainContent select, #MainContent textarea, #MainContent summary, #MainContent .price, .mobile-facets__footer');
    const blocked = !!overlay || Array.from(targets).some(target => {
      const r = target.getBoundingClientRect();
      if (!r.width || !r.height || getComputedStyle(target).visibility === 'hidden') return false;
      return r.right > area.left - 8 && r.left < area.right + 8 && r.bottom > area.top - 8 && r.top < area.bottom + 8;
    });
    root.classList.toggle('bb-chat-clear', blocked);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(check);
  }

  document.addEventListener('scroll', schedule, { capture: true, passive: true });
  document.addEventListener('toggle', () => { suspendWidgets(!!openDrawer()); schedule(); }, true);
  document.addEventListener('click', schedule, true);
  document.addEventListener('focusin', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  new MutationObserver(records => {
    if (records.every(record => record.target === document.documentElement)) return;
    suspendWidgets(!!openDrawer());
    schedule();
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class', 'view'] });
  check();
})();
